/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Watery_This_Nuthatch_HackInputs */

const en_watery_this_nuthatch_hack = /** @type {(inputs: Watery_This_Nuthatch_HackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show`)
};

const de_watery_this_nuthatch_hack = /** @type {(inputs: Watery_This_Nuthatch_HackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzeigen`)
};

/**
* | output |
* | --- |
* | "Show" |
*
* @param {Watery_This_Nuthatch_HackInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const watery_this_nuthatch_hack = /** @type {((inputs?: Watery_This_Nuthatch_HackInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Watery_This_Nuthatch_HackInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_watery_this_nuthatch_hack(inputs)
	return de_watery_this_nuthatch_hack(inputs)
});